<template>
  <v-dialog
      v-model="show"
      persistent
      scrollable
      width="unset"
      :fullscreen="$vuetify.breakpoint.mobile"
  >
    <v-card
        elevation="0"
        ref="dialog"
        :class="{'rounded-0': $vuetify.breakpoint.mobile, 'sm': !$vuetify.breakpoint.mobile}"
    >
      <v-card-title class="headline">
        Электронные чеки по счету
      </v-card-title>
      <v-card-text>
        <v-select
          v-model="currentBillId"
          item-value="id"
          :items="bills"
        >
          <template v-slot:selection="{item}">
            {{prepareBillTitle(item)}}
          </template>
          <template v-slot:item="{item}">
            {{prepareBillTitle(item)}}
          </template>
        </v-select>
        <div
          v-if="currentBill"
          class="invoice-preview"
        >
          <div class="header text-center">
            <p>
              Кассовый чек № {{currentBill.number}}
            </p>
            <p>
              {{currentBill.ts | localizedDateRu}}
            </p>
            <p>
              {{getPayerInfo(currentBill)}}
            </p>
            <p>
              {{getSNO(currentBill)}}
            </p>
            <p>
              {{getType(currentBill)}}
            </p>
          </div>
          <div
            v-for="(p, index) in currentBill.positions"
            :key="p.id"
            class="position"
          >
            <div class="line first-line">
              <span class="idx">{{index + 1}}.</span> {{p.name}}
<!--              ({{getPositionPaymentMethod(p)}}), {{getPositionPaymentObject(p)}}-->
            </div>
            <v-row
              class="line second-line"
              dense
              layout="row"
              no-gutters
            >
              <v-col>
                {{p.count}} x {{p.price | number}}
              </v-col>
              <v-col class="price">
                = {{p.sum | number}}
              </v-col>
            </v-row>
            <v-row
              class="line third-line"
              dense
              no-gutters
            >
              <v-col>
                {{getVatDescription(p.vat)}}
              </v-col>
              <v-col class="price">
                = {{p.vatSum}}
              </v-col>
            </v-row>
          </div>
          <div class="total">
            <v-row
              class="line first-line"
              dense
              no-gutters
            >
              <v-col>
                <b>ИТОГ</b>
              </v-col>
              <v-col class="price">
                <b>= {{currentBill.sum  | number}}</b>
              </v-col>
            </v-row>
            <v-row
              class="line second-line"
              dense
              no-gutters
            >
              <v-col>
                в т.ч. НДС:
              </v-col>
              <v-col class="price">
                {{currentBill.vatSum | number}}
              </v-col>
            </v-row>
            <v-row
              class="line third-line"
              dense
              no-gutters
            >
              <v-col>
                Всего платежей:
              </v-col>
              <v-col class="price">
                {{currentBill.payments.length}}
              </v-col>
            </v-row>
            <v-row
              v-for="(p, index) in currentBill.payments"
              class="line"
              dense
              no-gutters
              :key="p.id"
            >
              <v-col>
                <span class="idx">{{index + 1}}.</span> {{getPaymentType(p)}}
              </v-col>
              <v-col class="price">
                = {{p.sum  | number}}
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            text
            @click="$emit('close')"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {types} from '@/constants'
import Statuses from '@/services/statuses'

export default {
  name: 'DialogShowInvoiceBills',
  computed: {
    buyoutStatus () {
      return this.buyout ? Statuses.getStatuses()[this.buyout.status] : ''
    },
    currentBill () {
      return this.bills.find(b => b.id === this.currentBillId)
    },
    show: {
      get () {
        return this.bills.length
      },
      set (newShow) {
        return newShow
      }
    }
  },
  data () {
    return {
      currentBillId: null,
      statuses: Statuses.getStatuses()
    }
  },
  methods: {
    getVatDescription(vat){
      switch (vat) {
        case 'none':
          return 'без НДС';
        default:
          return `в т.ч. НДС ${vat}%`;
      }
    },
    getPayerInfo(bill){
      return `Email плательщика: ${bill.email}`
    },
    getPaymentType(p){
      return types.receipts.payments[p.paymentType] || p.paymentType
    },
    getPositionPaymentMethod(p){
      return (types.receipts.payments.methods[p.paymentMethod] || p.paymentMethod).toLowerCase()
    },
    getPositionPaymentObject(p){
      return (types.receipts.payments.objects[p.paymentObject] || p.paymentObject).toLowerCase()
    },
    getSNO(bill){
      return `Вид налогообложения: ${types.sno[bill.sno] || bill.sno}`
    },
    getType(bill){
      return `${types.receipts[bill.docType] || bill.docType}`
    },
    prepareBillTitle (bill) {
      return `Чек № ${bill.number} от ${this.$root.$options.filters['localizedDateRu'](bill.ts)} на сумму ${this.$root.$options.filters['number'](bill.sum, 2)}`
    }
  },
  props: {
    bills: {
      required: true,
      type: Array
    }
  },
  watch: {
    bills (val) {
      if (val.length) {
        this.currentBillId = val[0].id
      } else {
        this.currentBillId = null
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  p {
    font-size: 14px;
    margin: 5px 0;
  }
}
.line {
  margin: 5px 0;
}
.position,
.total {
  border-top: 2px dashed black;
  padding: 5px 0;
}
.idx {
  margin-right: 10px;
}
.position {
  .second-line {
    padding-left: 40px;
  }
}
.total {
  .first-line {
    font-size: 16px;
  }
}
.price {
  text-align: right;
  max-width: 100px;
}
</style>
